export const PROJECTS_ROUTE = '/projects'
export const BLOG_ROUTE = '/articles'
export const SERVICES_ROUTE = '/services'
export const EVENTS_ROUTE = '/events'

export const MAIN_PAGE_ROUTE = '/:lang'
export const SAMPLE_PAGE_ROUTE = '/:lang/:slug'
export const SAMPLE2_PAGE_ROUTE = '/:lang/page/:slug'
